module.exports = __webpack_public_path__ + "5d5393fccae794b719a41f89a9268c13.jpg";